// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qJ5Zs","controls":"styles_controls__3AfNk","charLimit":"styles_charLimit__2nj_o","input":"styles_input__1ZkG7","send":"styles_send__2BIzk"};